export const MAX_GREETING_LENGTH = 200;
